import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { StarIcon, BadgeCheckIcon } from 'lucide-react';
const testimonials = [{
  name: 'Alicia Mlodzieniewski',
  rating: 5,
  date: '05.07.2025',
  text: 'Meinem Hund schmeckt das Pulver. Er leckt auch nur das Pulver ab.\n\nEuer Konzept ist toll!'
}, {
  name: 'Pascal Pischkowski',
  rating: 5,
  date: '05.07.2025',
  text: 'Wir sind sehr zufrieden. Unserem Eddie hat es sehr bei seinen Magen-Darm Problemen geholfen.'
}, {
  name: 'Carmen Geist',
  rating: 5,
  date: '05.07.2025',
  text: 'Meine Lotta hat oft Magen-Darmprobleme....seit ich das regelmäßig unters Essen mische, hat sie einen gut geformten Stuhlgang. Bestimmt werde ich in der Zukunft noch mehr Positives verzeichnen können. Sehr gutes Produkt!'
}];
function Stars({
  count
}: {
  count: number;
}) {
  return <div className="flex gap-0.5" data-id="element-92">
      {Array.from({
      length: count
    }).map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" style={{
      color: '#D4A843'
    }} data-id="element-93" />)}
    </div>;
}
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function TestimonialsSection() {
  return <section className="w-full py-16" style={{
    backgroundColor: 'var(--color-cream)'
  }} data-id="element-94">
      <div className="max-w-3xl mx-auto px-4" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-96">
          <h3 className="font-handwritten text-3xl md:text-4xl mb-3" style={{
          color: 'var(--color-green)'
        }} data-id="element-97">
            Das sagen andere Hundebesitzer
          </h3>
          <p className="text-base" style={{
          color: 'var(--color-text-light)'
        }} data-id="element-98">
            Echte Erfahrungen von echten Hundemenschen
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="space-y-6" data-id="element-99">
          {testimonials.map(t => <motion.div key={t.name} variants={itemVariants} className="rounded-xl p-6 border" style={{
          backgroundColor: 'white',
          borderColor: 'var(--color-border)'
        }} data-id="element-100">
              <div className="flex flex-wrap items-center gap-3 mb-3" data-id="element-101">
                <div className="w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold" style={{
              backgroundColor: 'var(--color-green-light)',
              color: 'var(--color-green)'
            }} data-id="element-102">
                  {t.name[0]}
                </div>
                <p className="text-sm font-semibold" style={{
              color: 'var(--color-text)'
            }} data-id="element-103">
                  {t.name}
                </p>
                <Stars count={t.rating} data-id="element-104" />
                <span className="inline-flex items-center gap-1 text-xs px-2.5 py-1 rounded-full border" style={{
              color: 'var(--color-green)',
              borderColor: 'var(--color-green)',
              backgroundColor: 'var(--color-green-light)'
            }} data-id="element-105">
                  <BadgeCheckIcon className="w-3.5 h-3.5" data-id="element-106" />
                  Verifizierter Kunde
                </span>
              </div>
              <p className="text-base leading-relaxed whitespace-pre-line" style={{
            color: 'var(--color-text)'
          }} data-id="element-107">
                „{t.text}"
              </p>
              <p className="mt-3 text-xs text-right" style={{
            color: 'var(--color-text-light)'
          }} data-id="element-108">
                {t.date}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}